"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlBuilder = exports.stripHttpsProtocol = exports.ensureAbsoluteUrl = void 0;
class InternalUrlBuilder {
    pathname;
    hash;
    searchParams;
    constructor(pathname, hash, searchParams) {
        this.pathname = pathname;
        this.hash = hash;
        this.searchParams = searchParams;
    }
    appendSearchParams(searchParams) {
        const newSearchParams = new URLSearchParams(this.searchParams);
        Object.entries(searchParams).forEach(([key, value]) => {
            if (value) {
                newSearchParams.set(key, value);
            }
            else {
                newSearchParams.delete(key);
            }
        });
        return new InternalUrlBuilder(this.pathname, this.hash, newSearchParams);
    }
    removeSearchParams(...keys) {
        const newSearchParams = new URLSearchParams(this.searchParams);
        keys.forEach((key) => {
            newSearchParams.delete(key);
        });
        return new InternalUrlBuilder(this.pathname, this.hash, newSearchParams);
    }
    build() {
        const finalHash = this.hash ? `#${encodeURIComponent(this.hash)}` : "";
        const finalSearchParams = this.searchParams.toString() ? `?${this.searchParams}` : "";
        return `${this.pathname}${finalSearchParams}${finalHash}`;
    }
}
const ensureAbsoluteUrl = (url) => {
    if (!url) {
        return null;
    }
    if (/^https?:\/\//i.test(url)) {
        return url;
    }
    return `https://${url}`;
};
exports.ensureAbsoluteUrl = ensureAbsoluteUrl;
const stripHttpsProtocol = (url) => {
    if (!url) {
        return "";
    }
    return url.replace(/^https?:\/\//i, "");
};
exports.stripHttpsProtocol = stripHttpsProtocol;
const UrlBuilder = ({ pathname, hash, searchParams, }) => {
    return new InternalUrlBuilder(pathname, hash, searchParams ?? new URLSearchParams());
};
exports.UrlBuilder = UrlBuilder;
